import React from 'react';
import './ImpactPreview.css';

/**
 * "Auswirkungen" box inside the group/role popups of the player page. The caller derives the lines from
 * the preview response (they differ per action); server warnings are shown as a warning callout.
 * Uses no <p>, because `.infoContainer p` (Popup.css) would override the typography.
 */
function ImpactPreview({ lines = [], warnings = [], loading = false, failed = false }) {
  const visibleLines = lines.filter(Boolean);
  return (
    <div className={`impactPreview${loading ? ' isLoading' : ''}`} aria-live="polite">
      <span className="impactPreviewTitle">Auswirkungen</span>
      {visibleLines.length > 0 && (
        <ul className="impactPreviewList">
          {visibleLines.map((line, i) => <li key={i}>{line}</li>)}
        </ul>
      )}
      {loading && <span className="impactPreviewState">Vorschau wird berechnet …</span>}
      {failed && !loading && <span className="impactPreviewState">Vorschau nicht verfügbar – die Aktion ist trotzdem möglich.</span>}
      {warnings.filter(Boolean).map((w, i) => (
        <div key={i} className="impactPreviewWarning">{w}</div>
      ))}
    </div>
  );
}

// Shared wording for the future participations of a preview response.
export function futureParticipationsLine(preview, { apply, priceChanges = true } = {}) {
  if (!preview) return null;
  const n = Number(preview.futureParticipations ?? 0);
  if (n === 0) return 'Keine zukünftigen Anmeldungen betroffen.';
  const anmeldungen = n === 1 ? '1 zukünftige Anmeldung' : `${n} zukünftige Anmeldungen`;
  if (!apply) return `${anmeldungen} ${n === 1 ? 'behält' : 'behalten'} ihren bisherigen Preis.`;
  if (!priceChanges) return `${anmeldungen} ${n === 1 ? 'wird' : 'werden'} neu berechnet.`;
  const changes = Number(preview.priceChanges ?? 0);
  if (changes === 0) return `${anmeldungen} – die Preise bleiben gleich.`;
  return `${anmeldungen} – bis zu ${changes} ${changes === 1 ? 'bekommt' : 'bekommen'} einen neuen Preis (bezahlte und manuell gesetzte Preise bleiben).`;
}

export default ImpactPreview;
